import type { ReactNode, Ref } from 'react'
import { ContentLabel } from '@/components/ContentLabel'
import styles from './ListHeader.module.css'

interface ListHeaderProps {
  children?: ReactNode
  count?: number
  clickable?: boolean
  iconRight?: ReactNode
  ref?: Ref<HTMLDivElement>
}

/**
 * List header.
 */
export function ListHeader({
  children,
  count,
  clickable,
  iconRight,
  ref,
}: ListHeaderProps) {
  return (
    <ContentLabel clickable={clickable} iconRight={iconRight} ref={ref}>
      {children}
      {count !== undefined && <span className={styles.count}> ({count})</span>}
    </ContentLabel>
  )
}
